import React from "react";
import {
  convertThenFormat,
  formattedAmount,
  TODAYS_DATE_FORMATTED,
} from "../common-data/Converts";
import {
  Cash,
  OneDayLeft,
  Online,
  Partial,
  TotalEarning,
} from "../../exports/Images";
import {
  BlueClockIcon,
  FemaleIcon,
  GreenCheckIcon,
  HoldingMoneyIcon,
  MaleIcon,
  RedCrossIcon,
  SendCheckIcon,
  TotalSentIcon,
} from "../../images/icons/icons";
import DotLoaders from "./loaders/DotLoaders";

const CmnFilterStrctureCardBlock = ({
  from,
  targetStats,
  partialStatsData,
  allPaymentOnlineData,
  allPaymentCashData,
  allSubsTbData,
  allSubsPlanStatsData,
  allMaleFemaleBurification,
  partialPaymentInfo,
  ptCardData,
  salesTodayValues,
  filterType,
  totalSaleData,
  staffLeaveStats,
  staffLeavesYearStats,
  staffLeavesStats,
  totalMemberData,
  clickedCard,
  isLoading,
}) => {
  return (
    <div
      className={`filterblock cardblock ${
        targetStats && from === "daily-target" ? "personal-training" : ""
      }`}
    >
      {from === "payment-link" && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Online link</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Total sent</span>
              </div>

              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹{convertThenFormat(allPaymentOnlineData?.total_online || 0)}
                  {/* ₹{convertThenFormat(allPaymentOnlineData?.totalOnline || 0)} */}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Completed</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.total_online_completed || 0
                  )}
                  {/* ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.totalOnlineCompleted || 0
                  )} */}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Pending</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.total_online_pending || 0
                  )}
                  {/* ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.totalOnlinePending || 0
                  )} */}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <RedCrossIcon />
                </span>
                <span className="infoTag">Cancelled</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.total_online_cancelled || 0
                  )}
                  {/* ₹
                  {convertThenFormat(
                    allPaymentOnlineData?.totalOnlineCancelled || 0
                  )} */}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {from === "payment-link" && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Cash link</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Total sent</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹{convertThenFormat(allPaymentCashData?.totalCash || 0)}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Approved</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(
                    allPaymentCashData?.totalCashApproved || 0
                  )}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Pending</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(allPaymentCashData?.totalCashPending || 0)}
                </span>
              )}
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <RedCrossIcon />
                </span>
                <span className="infoTag">Not approved</span>
              </div>
              {isLoading ? (
                <span className="infoLoading">
                  <DotLoaders color="#151515" />
                </span>
              ) : (
                <span className="infoAMount">
                  ₹
                  {convertThenFormat(
                    allPaymentCashData?.totalCashNotApproved || 0
                  )}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {allSubsTbData && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Subscription Info</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Total subscription</span>
              </div>
              <span className="infoAMount">
                {allSubsTbData?.totalSubscription || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total Amount" />
                </span>
                <span className="infoTag">Total Amount</span>
              </div>
              <span className="infoAMount">
                ₹
                {allSubsTbData.totalAmount
                  ? formattedAmount(allSubsTbData.totalAmount)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Full Amount" />
                </span>
                <span className="infoTag">Full Amount</span>
              </div>
              <span className="infoAMount">
                ₹
                {allSubsTbData.fullAmount
                  ? formattedAmount(allSubsTbData.fullAmount)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Partial Amount" />
                </span>
                <span className="infoTag">Partial Amount</span>
              </div>
              <span className="infoAMount">
                ₹
                {allSubsTbData.partialAmount
                  ? formattedAmount(allSubsTbData.partialAmount)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total New" />
                </span>
                <span className="infoTag">Total New (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(allSubsTbData.totalNewAmount || 0)} (
                {formattedAmount(allSubsTbData.totalNew || 0)})
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total Renewals" />
                </span>
                <span className="infoTag">Total Renewals (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(allSubsTbData.totalRenewalsAmount || 0)} (
                {formattedAmount(allSubsTbData.totalRenewals || 0)})
              </span>
            </div>
          </div>
        </div>
      )}

      {allSubsPlanStatsData && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Plan Info</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Monthly Plan" />
                </span>
                <span className="infoTag">Monthly Plan (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allSubsPlanStatsData?.total_reg_monthly_amount || 0
                )}
                ({allSubsPlanStatsData?.total_reg_monthly || 0})
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Quarterly Plan" />
                </span>
                <span className="infoTag">Quarterly Plan (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allSubsPlanStatsData?.total_reg_quarterly__amount || 0
                )}
                ({allSubsPlanStatsData?.total_reg_quarterly || 0})
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Half Yearly Plan " />
                </span>
                <span className="infoTag">Half Yearly Plan (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allSubsPlanStatsData?.total_reg_half_yearly__amount || 0
                )}
                ({allSubsPlanStatsData?.total_reg_half_yearly || 0})
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Yearly Plan" />
                </span>
                <span className="infoTag">Yearly Plan (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allSubsPlanStatsData?.total_reg_yearly__amount || 0
                )}
                ({allSubsPlanStatsData?.total_reg_yearly || 0})
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Half Yearly Plan " />
                </span>
                <span className="infoTag">All Access Plan (Regular)</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allSubsPlanStatsData?.total_reg_allaccess__amount || 0
                )}
                ({allSubsPlanStatsData?.total_reg_allaccess || 0})
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="One Day Plan" />
                </span>
                <span className="infoTag">One Day Plan</span>
              </div>
              <span className="infoAMount">
                {convertThenFormat(
                  allSubsPlanStatsData?.total_oneday_subscriptions || 0
                )}
              </span>
            </div>
          </div>
        </div>
      )}

      {allMaleFemaleBurification && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Female & Male Subscriptions</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Monthly Plan" />
                </span>
                <span className="infoTag">couple plan</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  allMaleFemaleBurification?.total_couple_amount || 0
                )}
                ({allMaleFemaleBurification?.total_couple || 0})
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <FemaleIcon />
                </span>
                <span className="infoTag">total female subscription</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_female || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <MaleIcon />
                </span>
                <span className="infoTag">total male subscription</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_male || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <FemaleIcon />
                </span>
                <span className="infoTag">new female subscription</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_new_female || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <MaleIcon />
                </span>
                <span className="infoTag">new male subscription</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_new_male || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <FemaleIcon />
                </span>
                <span className="infoTag">female renewal</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_renewal_female || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <MaleIcon />
                </span>
                <span className="infoTag">male renewal</span>
              </div>
              <span className="infoAMount">
                {allMaleFemaleBurification?.total_renewal_male || 0}
              </span>
            </div>
          </div>
        </div>
      )}

      {partialPaymentInfo && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Partial Payments</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Total</span>
              </div>
              <span className="infoAMount">
                {convertThenFormat(partialPaymentInfo?.total_amount || 0)}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Total Completed</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  partialPaymentInfo?.total_completed_amount || 0
                )}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Total Pending</span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  partialPaymentInfo?.total_pending_amount || 0
                )}
              </span>
            </div>
          </div>
        </div>
      )}

      {ptCardData && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">PT Tracks</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Total Subscriptions</span>
              </div>
              <span className="infoAMount">
                {ptCardData?.total_subscription || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">PT Trial Complete</span>
              </div>
              <span className="infoAMount">
                {ptCardData?.pt_trial_complete || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">PT Trial Pending</span>
              </div>
              <span className="infoAMount">
                {ptCardData?.pt_trial_pending || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <SendCheckIcon />
                </span>
                <span className="infoTag">PT Converts</span>
              </div>
              <span className="infoAMount">{ptCardData?.pt_convert || 0}</span>
            </div>
          </div>
        </div>
      )}

      {salesTodayValues && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Sale Values</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total Earning" />
                </span>
                <span className="infoTag">Total Earnings</span>
              </div>
              <span className="infoAMount">
                ₹
                {salesTodayValues?.total
                  ? convertThenFormat(salesTodayValues.total)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={Cash} alt="Cash" />
                </span>
                <span className="infoTag">Cash</span>
              </div>
              <span className="infoAMount">
                ₹
                {salesTodayValues?.cash
                  ? convertThenFormat(salesTodayValues.cash)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={Online} alt="Online" />
                </span>
                <span className="infoTag">Online</span>
              </div>
              <span className="infoAMount">
                ₹
                {salesTodayValues?.online
                  ? convertThenFormat(salesTodayValues.online)
                  : 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={Partial} alt="Partial" />
                </span>
                <span className="infoTag">Partial</span>
              </div>
              <span className="infoAMount">
                ₹
                {salesTodayValues?.partial
                  ? convertThenFormat(salesTodayValues.partial)
                  : 0}
              </span>
            </div>
            {salesTodayValues?.total_one_day ? (
              <div className="infoBox">
                <div className="infoIconNAmount">
                  <span className="infoIcon infoImg">
                    <img src={OneDayLeft} alt="One Day Plan" />
                  </span>
                  <span className="infoTag">One Day Plan</span>
                </div>
                <span className="infoAMount">
                  {salesTodayValues?.total_one_day || 0}
                </span>
              </div>
            ) : null}

            {clickedCard === "today" ? (
              <>
                <div className="infoBox">
                  <div className="infoIconNAmount">
                    <span className="infoIcon infoImg">
                      <img src={TotalEarning} alt="Total Earning" />
                    </span>
                    <span className="infoTag">Pre Gym Sales</span>
                  </div>
                  <span className="infoAMount">
                    ₹{convertThenFormat(salesTodayValues?.preSaleGymSales || 0)}
                  </span>
                </div>

                <div className="infoBox">
                  <div className="infoIconNAmount">
                    <span className="infoIcon infoImg">
                      <img src={TotalEarning} alt="Total Earning" />
                    </span>
                    <span className="infoTag">Regular Gym Sales</span>
                  </div>
                  <span className="infoAMount">
                    ₹{convertThenFormat(salesTodayValues?.regularGymSales || 0)}
                  </span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}

      {targetStats && (!filterType || filterType === "overall") && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">overall</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">Total Target</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.target_value
                  ? convertThenFormat(targetStats.target_value)
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">total Daily Target</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.ideal_target_total || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">Total target acheived</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.target_value_acheived
                  ? convertThenFormat(targetStats.target_value_acheived)
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">Total Target Remaining</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.remaining_target
                  ? convertThenFormat(targetStats.remaining_target)
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  total ideal target to acheive as today {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  targetStats?.ideal_target_as_today_total || 0
                )}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">Total deficit</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats.deficit_total || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  Total Target to acheive Today {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.today_target || 0)}
              </span>
            </div>
          </div>
        </div>
      )}

      {targetStats && (!filterType || filterType === "regular") && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">regular</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">regular Target</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.regular_member_target?.total
                  ? convertThenFormat(targetStats?.regular_member_target?.total)
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">Regular Daily Target</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.ideal_target_regular || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">regular target acheived</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.regular_member_target?.acheived
                  ? convertThenFormat(
                      targetStats?.regular_member_target?.acheived
                    )
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">regular Target Remaining</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.regular_member_target?.remaining
                  ? convertThenFormat(
                      targetStats?.regular_member_target?.remaining
                    )
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  regular ideal Target To Acheive As Today{" "}
                  {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹
                {convertThenFormat(
                  targetStats?.ideal_target_as_today_regular || 0
                )}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">regular deficit</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats.deficit_regular || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  Regular Target to acheive Today {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.today_target_regular || 0)}
              </span>
            </div>
          </div>
        </div>
      )}

      {targetStats && (!filterType || filterType === "pt") && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Personal Training</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">PT Target</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.pt_membership_target?.total
                  ? convertThenFormat(targetStats?.pt_membership_target?.total)
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">PT Daily Target</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.ideal_target_pt || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">PT target acheived</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.pt_membership_target?.acheived
                  ? convertThenFormat(
                      targetStats?.pt_membership_target?.acheived
                    )
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">PT Target Remaining</span>
              </div>
              <span className="infoAMount">
                ₹
                {targetStats?.pt_membership_target?.remaining
                  ? convertThenFormat(
                      targetStats?.pt_membership_target?.remaining
                    )
                  : 0}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  PT ideal Target To Acheive As Today {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.ideal_target_as_today_pt || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">PT deficit</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats.deficit_pt || 0)}
              </span>
            </div>

            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoTag">
                  PT Target To Acheive Today {TODAYS_DATE_FORMATTED}
                </span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(targetStats?.today_target_pt || 0)}
              </span>
            </div>
          </div>
        </div>
      )}

      {totalSaleData ? (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Sale Values</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total Amount" />
                </span>
                <span className="infoTag">Total Amount</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(totalSaleData || 0)}{" "}
                {totalMemberData && `(${totalMemberData})`}
              </span>
            </div>
          </div>
        </div>
      ) : null}

      {staffLeaveStats && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Staff Leaves</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Staff On Leave Today" />
                </span>
                <span className="infoTag">Staff On Leave Today</span>
              </div>
              <span className="infoAMount">
                {staffLeaveStats?.staff_onleave_today || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Staff Approval Pending</span>
              </div>
              <span className="infoAMount">
                {staffLeaveStats?.total_leave_days_pending || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Approved Leaves</span>
              </div>
              <span className="infoAMount">
                {staffLeaveStats?.total_leave_days_approved || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <RedCrossIcon />
                </span>
                <span className="infoTag">Rejected Leaves</span>
              </div>
              <span className="infoAMount">
                {staffLeaveStats?.total_leave_days_rejected || 0}
              </span>
            </div>
          </div>
        </div>
      )}

      {staffLeavesYearStats && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Leave Details</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Leaves This Year" />
                </span>
                <span className="infoTag">Leaves This Year</span>
              </div>
              <span className="infoAMount">
                {staffLeavesYearStats?.total_leave_this_yr || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Leaves Used This Year</span>
              </div>
              <span className="infoAMount">
                {staffLeavesYearStats?.leave_used_this_yr || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Leave Available This Year</span>
              </div>
              <span className="infoAMount">
                {staffLeavesYearStats?.total_available_this_yr || 0}
              </span>
            </div>
          </div>
        </div>
      )}

      {staffLeavesStats && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Leave Details</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon infoImg">
                  <img src={TotalEarning} alt="Total Paid Leaves" />
                </span>
                <span className="infoTag">Total Paid Leaves</span>
              </div>
              <span className="infoAMount">
                {staffLeavesStats?.total_paid_leave || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Total Unpaid Leaves Taken</span>
              </div>
              <span className="infoAMount">
                {staffLeavesStats?.total_unpaid_leave || 0}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <RedCrossIcon />
                </span>
                <span className="infoTag">Salary Deducted</span>
              </div>
              <span className="infoAMount">
                {convertThenFormat(staffLeavesStats?.deducted_salary || 0)}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Final Salary</span>
              </div>
              <span className="infoAMount">
                {convertThenFormat(staffLeavesStats?.salary || 0)}
              </span>
            </div>
          </div>
        </div>
      )}

      {partialStatsData && (
        <div className="infoCard">
          <div className="cardHeadindNIcon">
            <h3 className="cardHeading">Partial Payments</h3>
            <span className="cardIcon">
              <HoldingMoneyIcon />
            </span>
          </div>
          <div className="cardgrayline"></div>
          <div className="cardInfos">
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <TotalSentIcon />
                </span>
                <span className="infoTag">Today</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(partialStatsData?.total_today || 0)}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <GreenCheckIcon />
                </span>
                <span className="infoTag">Total Pending</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(partialStatsData?.total_pending || 0)}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Total Upcoming</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(partialStatsData?.total_upcoming || 0)}
              </span>
            </div>
            <div className="infoBox">
              <div className="infoIconNAmount">
                <span className="infoIcon">
                  <BlueClockIcon />
                </span>
                <span className="infoTag">Total Overdue</span>
              </div>
              <span className="infoAMount">
                ₹{convertThenFormat(partialStatsData?.total_overdue || 0)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CmnFilterStrctureCardBlock;
